// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ecl-gauge {
   display: flex;
   flex-direction: column;
   align-items: center;
   width: 100%;
   height: 100%;
   padding: var(--padding);
   min-height: 80px;
}

.ecl-gauge .gauge-label {
   padding: 0;
   font-weight: normal;
}

.ecl-gauge .gauge-value {
   font-size: 1.25rem;
   font-weight: bold;
   padding: 0
}

.ecl-gauge .gauge-labels-div,
.ecl-gauge .gauge-values-div {
   width: 95%;
   display: flex;
   justify-content: space-between;
}

.ecl-gauge .gauge-value.left {
   color: var(--red-fire)
}

.ecl-gauge .gauge-container {
   width: 95%;
   position: relative;
}

.ecl-gauge .total-gauge {
   background-color: var(--dust-gray);
   height: 10px;
   width: 100%;
   border-radius: var(--border-radius);
   position: absolute;
   left: 0px;
}

.ecl-gauge .value-gauge {
   background-color: var(--red-fire);
   height: 10px;
   border-radius: var(--border-radius);
   position: absolute;
   left: 0px;
}

.ecl-gauge .value-gauge.full-gauge {
   background-color: var(--jade-glow);
   max-width: 100%;
}

.ecl-gauge .gauge-value.full-gauge-text,
.ecl-gauge .gauge-value.full-gauge-text {
   color: var(--jade-glow);
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLDataViz/ECLGauge/ECLGauge.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,sBAAsB;GACtB,mBAAmB;GACnB,WAAW;GACX,YAAY;GACZ,uBAAuB;GACvB,gBAAgB;AACnB;;AAEA;GACG,UAAU;GACV,mBAAmB;AACtB;;AAEA;GACG,kBAAkB;GAClB,iBAAiB;GACjB;AACH;;AAEA;;GAEG,UAAU;GACV,aAAa;GACb,8BAA8B;AACjC;;AAEA;GACG;AACH;;AAEA;GACG,UAAU;GACV,kBAAkB;AACrB;;AAEA;GACG,kCAAkC;GAClC,YAAY;GACZ,WAAW;GACX,mCAAmC;GACnC,kBAAkB;GAClB,SAAS;AACZ;;AAEA;GACG,iCAAiC;GACjC,YAAY;GACZ,mCAAmC;GACnC,kBAAkB;GAClB,SAAS;AACZ;;AAEA;GACG,kCAAkC;GAClC,eAAe;AAClB;;AAEA;;GAEG,uBAAuB;AAC1B","sourcesContent":[".ecl-gauge {\r\n   display: flex;\r\n   flex-direction: column;\r\n   align-items: center;\r\n   width: 100%;\r\n   height: 100%;\r\n   padding: var(--padding);\r\n   min-height: 80px;\r\n}\r\n\r\n.ecl-gauge .gauge-label {\r\n   padding: 0;\r\n   font-weight: normal;\r\n}\r\n\r\n.ecl-gauge .gauge-value {\r\n   font-size: 1.25rem;\r\n   font-weight: bold;\r\n   padding: 0\r\n}\r\n\r\n.ecl-gauge .gauge-labels-div,\r\n.ecl-gauge .gauge-values-div {\r\n   width: 95%;\r\n   display: flex;\r\n   justify-content: space-between;\r\n}\r\n\r\n.ecl-gauge .gauge-value.left {\r\n   color: var(--red-fire)\r\n}\r\n\r\n.ecl-gauge .gauge-container {\r\n   width: 95%;\r\n   position: relative;\r\n}\r\n\r\n.ecl-gauge .total-gauge {\r\n   background-color: var(--dust-gray);\r\n   height: 10px;\r\n   width: 100%;\r\n   border-radius: var(--border-radius);\r\n   position: absolute;\r\n   left: 0px;\r\n}\r\n\r\n.ecl-gauge .value-gauge {\r\n   background-color: var(--red-fire);\r\n   height: 10px;\r\n   border-radius: var(--border-radius);\r\n   position: absolute;\r\n   left: 0px;\r\n}\r\n\r\n.ecl-gauge .value-gauge.full-gauge {\r\n   background-color: var(--jade-glow);\r\n   max-width: 100%;\r\n}\r\n\r\n.ecl-gauge .gauge-value.full-gauge-text,\r\n.ecl-gauge .gauge-value.full-gauge-text {\r\n   color: var(--jade-glow);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
